import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from '../../../environments/environment';
import { IStrategy } from '../../models/IStrategy';
import {StrtDashboardRequest} from '../../shared/models/api/StrtDashboardRequest';
import {StrtCopyPlanRequest} from '../../shared/models/api/StrtCopyPlanRequest';


@Injectable()
export class StrategiesService {
  private baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  list(institutionId: number, dashboardRequest: StrtDashboardRequest): Observable<IStrategy[]> {
    return this.http.post<IStrategy[]>(`${this.baseUrl}/strategies/dashboards/institutions/${institutionId}`, dashboardRequest);
  }

  search(institutionId: number, dashboardRequest: StrtDashboardRequest): Observable<IStrategy[]> {
    return this.http.post<IStrategy[]>(`${this.baseUrl}/strategies/dashboards/search/${institutionId}`, dashboardRequest);
  }

  totalCount(institutionId: number, includeHierarchy: boolean): Observable<number> {
    return this.http.post<number>(
      `${this.baseUrl}/strategies/dashboards/institutions/${institutionId}/count?includeHierarchy=${includeHierarchy}`, {});
  }

  name(institutionId: number, strategyName: string): Observable<{duplicateName: boolean}> {
    return this.http.get<{duplicateName: boolean}>
      (`${this.baseUrl}/strategies/institutions/${institutionId}/names`, this.createRequestOptions({strategyName}));
  }

  createStrategy(strategyName: string, targetStartDate: Date, targetEndDate: Date, institutionId: number): Observable<IStrategy> {
    return this.http.post<IStrategy>(`${this.baseUrl}/strategies`, {strategyName, targetStartDate, targetEndDate, institutionId});
  }

  deleteStrategy(strategyId: number): Observable<{}> {
    return this.http.delete<{}>(`${this.baseUrl}/strategies/${strategyId}`);
  }

  editStrategy(strategyId: number, strategyName: string, targetStartDate: Date, targetEndDate: Date): Observable<IStrategy> {
    return this.http.put<IStrategy>(`${this.baseUrl}/strategies/${strategyId}`, {strategyId, strategyName, targetStartDate, targetEndDate});
  }

  copyStrategy(copyRequest: StrtCopyPlanRequest): Observable<IStrategy> {
    return this.http.post<IStrategy>(`${this.baseUrl}/strategies/copy`, copyRequest);
  }

  downloadSystemAggReport(dashboardRequest: StrtDashboardRequest, institutionId: number): Observable<any> {
    const body = {
      'includeHierarchy': dashboardRequest.includeHierarchy,
      'filters': dashboardRequest.filters
    };
    return this.http.post<IStrategy>(`${this.baseUrl}/report/submit-status-monitoring-rpt/${institutionId}`, body);
  }

  private createRequestOptions(paramsObj?: { [key: string]: string; }) {
    const params: HttpParams = paramsObj
      ? Object.keys(paramsObj).reduce(
        (previous, key) => previous.set(key, paramsObj[key]),
        new HttpParams({ encoder: new HttpUrlEncodingCodec()}))
      : undefined;
    return { params };
  }
}
